(function ($) {

'use strict';

	/**
	 * form enter key handler for all input elements
	 * @returns {bool} false
	 */
	$.setFormReturnKeyHandler = function () {
		// form enter key handler for selects,checkboxes,radios
		// !!! don't use input text types text, search, email ..., 
		//	otherwise the autocomplete feature is blocked and a unwanted submit is fired
		$('form').find('select, input[type="checkbox"], input[type="radio"]').on('keydown', function (e) {
			if (e.which === 13) {
				$(this).closest('form').find('input[type="submit"]').trigger('click');
			}
		});

	};
}(jQuery));